// import React from "react";
// import { FaPhone, FaWhatsapp } from "react-icons/fa"; // Import icons
// import "./FloatingButtons.css"; // Import CSS for styling

// const FloatingButtons = () => {
//   return (
//     <div className="floating-buttons">
//       {/* Call Button */}
//       <a
//         href="tel:+917276269043"
//         className="floating-button call-button"
//         title="Call Now"
//       >
//         <FaPhone />
//       </a>

//       {/* WhatsApp Button */}
//       <a
//         href="https://wa.me/917276269043"
//         className="floating-button whatsapp-button"
//         title="Chat on WhatsApp"
//       >
//         <FaWhatsapp />
//       </a>
//     </div>
//   );
// };

// export default FloatingButtons;

import React from "react";
import { FaPhone, FaWhatsapp, FaFacebook, FaInstagram } from "react-icons/fa"; // Import icons
import "./FloatingButtons.css"; // Import CSS for styling

const FloatingButtons = () => {
  return (
    <div className="floating-buttons">
      {/* Call Button */}
      <a
        href="tel:+919834430943"
        className="floating-button call-button"
        title="Call Now"
      >
        <FaPhone />
      </a>

      {/* WhatsApp Button */}
      <a
        href="https://wa.me/919834430943?text=Hello%20Anvika%20Industrial%20Supplier%2C%20I%20am%20interested%20in%20your%20packaging%20products%20and%20would%20like%20to%20know%20more%20details.%20Please%20get%20in%20touch%20with%20me."
        className="floating-button whatsapp-button"
        title="Chat on WhatsApp"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaWhatsapp />
      </a>

      {/* Facebook Button */}
      {/* <a
        href="https://www.facebook.com/YOUR_PAGE"
        className="floating-button facebook-button"
        title="Visit Facebook"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaFacebook />
      </a> */}

      {/* Instagram Button */}
      {/* <a
        href="https://www.instagram.com/kenwood_furnitech_09/?hl=en"
        className="floating-button instagram-button"
        title="Visit Instagram"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaInstagram />
      </a> */}
    </div>
  );
};

export default FloatingButtons;
